import React, { useEffect } from "react";
import ProfileCard from "../Components/ProfileCard";
import { useNavigate } from "react-router-dom";
import { useGetprofileapiQuery } from "../Store/Middleware/api/getProfileAPI";

const ProfileSection = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Profile Section | Career Portal";
  }, []);

  return (
    <section className="openPositionSection">
      <div className="openPositionHeader">
        <div className="openPosition-m1">My Profile</div>
        <div className="openPosition-m2">
          Live your best life and do your best work with us
        </div>
      </div>
      <div className="openPosition-m3" style={{ paddingTop: "47px" }}>
        <div className="openPosition-Card">
          <div className="profileSection-section">
            <ProfileCard />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProfileSection;
